module.exports = "<div class=\"app\">\n  <app-terraineditor></app-terraineditor>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main